import { createReducer } from '@reduxjs/toolkit';

import { toastrShowError, toastrShowInfo, toastrShowSuccess, toastrUpdateIsShow, toastrUpdateMessage, toastrUpdateType } from './toastrActions.js';

const initialState = {
  isShow: false,
  message: 'Appearance saved',
  type: 'success',
};

const user = createReducer(initialState, (builder) => {
  builder
    .addCase(toastrUpdateIsShow, (state, { payload: isShow }) => ({ ...state, isShow }))
    .addCase(toastrUpdateMessage, (state, { payload: message }) => ({ ...state, message }))
    .addCase(toastrUpdateType, (state, { payload: type }) => ({ ...state, type }))
    .addCase(toastrShowSuccess, (state, { payload = 'Saved' }) => ({ ...state, isShow: true, type: 'success', message: payload }))
    .addCase(toastrShowError, (state, { payload: message }) => ({ ...state, isShow: true, type: 'error', message }))
    .addCase(toastrShowInfo, (state, { payload: message }) => ({ ...state, isShow: true, type: 'info', message }));
});

export default user;
